import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GroupDetailModel } from '@app/core/models/groups/group-detail.model';
import { ConfigService } from '@core/config/config.service';
import { AuthService } from '@core/guards/auth.service';
import { HttpService } from '@core/http/http.service';
import { GroupTypeModel } from '@core/models/groups/group-type.model';
import { GroupModel } from '@core/models/groups/group.model';
import { UserModel } from '@core/models/users/user.model';
import { ImportReportModel } from '@core/models/administration/imports/import-report.model';
import { Observable } from 'rxjs';
import { PagedResult } from '../models/paged-result.model';
import { PagingParametersModel } from '../models/shared/paging-parameters.model';
import { GroupSearchCriteriaModel } from '../models/groups/group-search-criteria.model';
import { ReferentialItem } from '../models/shared/referential-item.model';

@Injectable({
  providedIn: 'root'
})
export class GroupService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'groups');
  }

  getGroupsByType(groupsType?: GroupTypeModel[]): Observable<GroupModel[]> {
    if (!groupsType) {
      return this.invokeGet<GroupModel[]>("");
    }
    return this.invokeGet<GroupModel[]>("", { groupsType: groupsType });
  }

  getGroupById(groupId: number) {
    return this.getById<GroupModel>(groupId);
  }

  getGroupUsersById(groupId: number): Observable<UserModel[]> {
    return this.invokeGet(`${groupId}/users`)
  }

  createGroup(groupDetailModel: GroupDetailModel) {
    return this.invokePost(groupDetailModel);
  }

  updateGroupById(groupId: number, groupDetailModel: GroupDetailModel) {
    const result = this.updateById(groupDetailModel, groupId);
    return result;
  }

  getGroupsForForward(): Observable<GroupModel[]> {
    return this.invokeGet<GroupModel[]>(`forward`)
  }
  activateGroup(groupId: string): Observable<any> {
    return this.invokePut(null, `${groupId}/activate`);
  }

  deactivateGroup(groupId: string): Observable<any> {
    return this.invokePut(null, `${groupId}/deactivate`);
  }

  transferUsers(sourceGroupId: number, targetGroupId: number): Observable<any> {
    return this.invokePut(null, `users/${sourceGroupId}/transfer/${targetGroupId}`);
  }

  importGroups(files: File[]): Observable<ImportReportModel[]> {
    return this.invokeUploadFiles(files, `import`);
  }

  searchGroups(sort?: string, order?: string, page?: number, size?: number, searchCriteria?: GroupSearchCriteriaModel): Observable<PagedResult<GroupModel>> {
    const pagingParameters = new PagingParametersModel(sort, order, page + 1, size);
    const invoicesDataSource = this.invokeGet<PagedResult<GroupModel>>('search', searchCriteria, pagingParameters);
    return invoicesDataSource;
  }

  getPagedGroups(groupSearchCriteriaModel: GroupSearchCriteriaModel, sort?: string, order?: string, page?: number, size?: number): Observable<PagedResult<ReferentialItem>> {
    const pagingParameters = new PagingParametersModel(sort, order, page + 1, size);
    const userGroups = this.invokeGet<PagedResult<ReferentialItem>>(`referential`, groupSearchCriteriaModel, pagingParameters);
    return userGroups;
  }
}
